import { render, staticRenderFns } from "./ItemTitle.vue?vue&type=template&id=7a96f463&"
import script from "./ItemTitle.vue?vue&type=script&lang=js&"
export * from "./ItemTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports